import React from "react";
import { BodyChiSiamoPage } from "../components/BodyChiSiamoPage";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { PoliclinicoMapComponent } from "../components/PoliclinicoMapComponent";

export const ChiSiamo = ({ history }) => {
  return (
    <React.Fragment>
      <Header history={history} />
      <BodyChiSiamoPage />
      <PoliclinicoMapComponent />
      <Footer />
    </React.Fragment>
  );
};
